import './App.css';
import Welcome from "./landingpage/Welcome";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Auth from "./auth/Auth";

function App() {
  return (
      <div>
          <BrowserRouter>
              <Routes>
                  <Route path={"/"} element={<Welcome></Welcome>}> </Route>
                  <Route path={"/login"} element={<Auth/>}> </Route>
              </Routes>
          </BrowserRouter>
      </div>
  );
}
export default App;
